import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { stringFormat } from './breadcrumb.util';
import { IBreadcrumb } from './breadcrumb.model';
import { Observable, of } from 'rxjs';

export class BreadcrumbResolve  {
  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IBreadcrumb[]> | Promise<IBreadcrumb[]> | IBreadcrumb[] {
    const data = route.routeConfig.data;
    const path = this.getFullPath(route);

    let text =
      typeof data.breadcrumbs === 'string'
        ? data.breadcrumbs
        : data.breadcrumbs.text || data.text || path;
    text = stringFormat(text, route.data);

    const crumbs: IBreadcrumb[] = [
      {
        text: text,
        path: path
      }
    ];

    return of(crumbs);
  }

  public getFullPath(route: ActivatedRouteSnapshot): string {
    const relativePath = (segments: UrlSegment[]) =>
      segments.reduce((a, v) => (a += '/' + v.path), '');
    const fullPath = (routes: ActivatedRouteSnapshot[]) =>
      routes.reduce((a, v) => (a += relativePath(v.url)), '');

    return fullPath(route.pathFromRoot);
  }
}
